import type { TranslationDict } from '../en';

const fi: TranslationDict = {
  // ─── Header ───
  'header.buy': 'Osta',
  'header.sell': 'Myy',

  // ─── SpendCard ───
  'spend.label': 'Käytät',
  'spend.placeholderFiat': '250',
  'spend.placeholderCrypto': '0.01',

  // ─── ReceiveCard ───
  'receive.label': 'Saat',

  // ─── PaymentCard ───
  'payment.label': 'Maksutapa',
  'payment.select': 'Valitse',
  'provider.label': 'By',
  'provider.select': 'Select',
  'provider.unavailable': 'Unavailable',
  'provider.unavailablePayment': 'Payment method not supported',
  'provider.unavailableCountry': 'Region not supported',
  'provider.unavailableCurrency': 'Currency not supported',
  'provider.unavailableNetwork': 'Network not supported',
  'payment.noneAvailable': 'Tälle parille ei ole maksutapoja saatavilla',

  // ─── WalletCard ───
  'wallet.label': 'Vastaanottavan lompakon osoite',
  'wallet.placeholderBuy': 'Syötä vastaanotto-osoitteesi',
  'wallet.placeholderSell': 'Syötä lähetysosoitteesi',
  'wallet.validating': 'Osoitetta tarkistetaan...',
  'wallet.invalid': 'Syötä kelvollinen lompakko-osoite',
  'wallet.invalidServer': 'Virheellinen lompakko-osoite',

  // ─── CtaButton ───
  'cta.buy': 'Osta {crypto}',
  'cta.sell': 'Myy {crypto}',
  'cta.gettingPrice': 'Haetaan parasta hintaa...',
  'cta.processing': 'Käsitellään...',

  // ─── Footer ───
  'footer.poweredBy': 'Palvelun tarjoaa ',
  'footer.brand': 'NowRamp',

  // ─── Rate Breakdown ───
  'rate.title': 'Kurssin erittely',
  'rate.close': 'Sulje',
  'rate.updatesIn': 'Kurssi päivittyy 00:{seconds} kuluttua',
  'rate.noQuote': 'Tarjousta ei saatavilla',
  'rate.exchangeRate': 'Vaihtokurssi',
  'rate.processingFee': 'Käsittelymaksu',
  'rate.networkFee': 'Verkkomaksu',
  'rate.provider': 'Palveluntarjoaja',

  // ─── Toast ───
  'toast.orderCreated': 'Tilaus luotu',
  'toast.redirecting': 'Ohjataan kassalle...',
  'toast.orderFailed': 'Tilaus epäonnistui',
  'toast.couldNotCreate': 'Tilausta ei voitu luoda',
  'toast.quoteError': 'Tarjousvirhe',
  'toast.noProviders': 'Ei palveluntarjoajia',
  'toast.somethingWrong': 'Jotain meni pieleen',

  // ─── Form errors ───
  'error.amountZero': 'Summan on oltava suurempi kuin 0',
  'error.minAmountFiat': 'Vähimmäissumma on {min} {currency}',
  'error.minAmountCrypto': 'Vähimmäissumma on {min} {currency}',
  'error.noProviders': 'Tälle yhdistelmälle ei ole palveluntarjoajia saatavilla',
  'error.currencyUnavailableBuy': 'Tämä valuutta ei ole saatavilla ostoille',
  'error.currencyUnavailableSell': 'Tämä valuutta ei ole saatavilla myynneille',

  // ─── Parity banner ───
  'parity.info': 'Sinulta veloitetaan {receiveAmount} {crypto}, ja loput {spendAmount} {fiat} asti hyvitetään {partner}-tilillesi',

  // ─── Redirect Screen ───
  'redirect.secureBadge': 'Turvallinen maksu',
  'redirect.title': 'Jatka maksua',
  'redirect.description': 'Sinut ohjataan {gateway}-sivustolle maksun suorittamiseksi.',
  'redirect.countdown': 'Ohjaus {seconds} sekunnin kuluttua...',
  'redirect.openTab': 'Avaa ACH uudessa välilehdessä',
  'redirect.cancel': 'Peruuta',

  // ─── Checkout Step ───
  'checkout.noOrder': 'Tilausta ei löydy',
  'checkout.goBack': 'Palaa takaisin',
  'checkout.expired': 'Kassa vanhentunut',
  'checkout.expiredDesc': 'Istunto on vanhentunut. Yritä uudelleen.',
  'checkout.startOver': 'Aloita alusta',
  'checkout.cancel': 'Peruuta',
  'checkout.loading': 'Ladataan kassaa...',
  'checkout.iframeTitle': 'Palveluntarjoajan kassa',
  'checkout.widgetTitle': 'Maksukassa',
  'checkout.unknownMethod': 'Tuntematon kassamenetelmä',

  // ─── Processing Step ───
  'processing.default': 'Tilaustasi käsitellään...',
  'processing.pending': 'Odotetaan maksuvarmentoa...',
  'processing.active': 'Tapahtumaasi käsitellään...',
  'processing.generic': 'Käsitellään...',
  'processing.checkingStatus': 'Tarkistetaan tila...',
  'processing.orderId': 'Tilausnumero',
  'processing.provider': 'Palveluntarjoaja',
  'processing.amount': 'Summa',
  'processing.receiving': 'Vastaanottaminen',
  'processing.network': 'Verkko',
  'processing.toAddress': 'Kohdeosoite',
  'processing.usuallyMinutes': 'Tämä kestää yleensä muutaman minuutin.',
  'processing.safeToClose': 'Voit sulkea tämän sivun turvallisesti – lähetämme sinulle sähköpostia, kun kaikki on valmis.',

  // ─── Complete Step ───
  'complete.buyTitle': 'Osto valmis!',
  'complete.sellTitle': 'Myynti valmis!',
  'complete.buyDesc': '{crypto} on lähetetty lompakkoosi.',
  'complete.sellDesc': '{fiat}-maksuasi käsitellään.',
  'complete.amountBuy': 'Vastaanotettu summa',
  'complete.amountSell': 'Myyty summa',
  'complete.paidBuy': 'Maksettu summa',
  'complete.paidSell': 'Maksettava summa',
  'complete.network': 'Verkko',
  'complete.wallet': 'Lompakko',
  'complete.transaction': 'Tapahtuma',
  'complete.provider': 'Palveluntarjoaja',
  'complete.orderId': 'Tilausnumero',
  'complete.completed': 'Valmis',
  'complete.viewExplorer': 'Näytä lohkoketjussa',
  'complete.done': 'Valmis',

  // ─── Error Step ───
  'errorStep.failed': 'Maksu epäonnistui',
  'errorStep.cancelled': 'Tilaus peruutettu',
  'errorStep.expired': 'Tilaus vanhentunut',
  'errorStep.refunded': 'Tilaus palautettu',
  'errorStep.unknown': 'Jotain meni pieleen',
  'errorStep.failedBuy': 'Maksuasi ei voitu käsitellä. Yritä uudelleen tai käytä eri maksutapaa.',
  'errorStep.failedSell': 'Myyntiäsi ei voitu käsitellä. Yritä uudelleen.',
  'errorStep.cancelledBuy': 'Tilauksesi peruutettiin. Mitään maksua ei käsitelty.',
  'errorStep.cancelledSell': 'Myyntisi peruutettiin. Kryptovaluuttaa ei siirretty.',
  'errorStep.expiredBuy': 'Tilauksesi on vanhentunut. Aloita uusi osto.',
  'errorStep.expiredSell': 'Tilauksesi on vanhentunut. Aloita uusi myynti.',
  'errorStep.refundedBuy': 'Maksusi on palautettu. Varat näkyvät tililläsi 5–10 arkipäivän kuluessa.',
  'errorStep.refundedSell': 'Kryptovaluuttasi on palautettu. Varat näkyvät lompakossasi pian.',
  'errorStep.genericDesc': 'Odottamaton virhe tapahtui. Yritä uudelleen.',
  'errorStep.orderId': 'Tilausnumero',
  'errorStep.tryAgain': 'Yritä uudelleen',
  'errorStep.startOver': 'Aloita alusta',
  'errorStep.return': 'Palaa',
  'errorStep.needHelp': 'Tarvitsetko apua? Ota yhteyttä ',
  'errorStep.reference': 'Viite: {orderId}',

  // ─── Confirm Step ───
  'confirm.buyTitle': 'Vahvista osto',
  'confirm.sellTitle': 'Vahvista myynti',
  'confirm.loading': 'Ladataan...',
  'confirm.provider': 'Palveluntarjoaja',
  'confirm.youPay': 'Maksat',
  'confirm.youSell': 'Myyt',
  'confirm.youReceive': 'Saat',
  'confirm.wallet': 'Lompakko',
  'confirm.network': 'Verkko',
  'confirm.refundAddress': 'Palautusosoite',
  'confirm.parityNote': 'Palveluntarjoajan veloittama summa voi poiketa. Loput {amount} {crypto} asti hyvitetään {partner}-tilillesi.',
  'confirm.processing': 'Käsitellään...',
  'confirm.confirmPay': 'Vahvista ja maksa',
  'confirm.confirmSell': 'Vahvista ja myy',
  'confirm.payout': '{currency}-maksu',

  // ─── Modals ───
  'modal.selectFiat': 'Valitse fiat-valuutta',
  'modal.selectCrypto': 'Valitse kryptovaluutta',
  'modal.choosePayment': 'Valitse maksutapa',
  'modal.selectCountry': 'Valitse maasi',
  'modal.selectLanguage': 'Select language',
  'modal.popular': 'Suosittu',
  'modal.recommended': 'Suositeltu',
  'modal.noCurrencies': 'Valuuttoja ei löydy',
  'modal.noPaymentMethods': 'Maksutapoja ei löydy',
  'modal.noCountries': 'Maita ei löydy',
  'modal.noLanguages': 'No languages found',

  // ─── Settings ───
  'settings.location': 'Sijainti',
  'settings.darkMode': 'Tumma tila',
  'settings.privacy': 'Tietosuojakäytäntö',
  'settings.terms': 'Käyttöehdot',
  'settings.language': 'Kieli',

  // ─── Additional ───
  'modal.chooseRamp': 'Valitse Ramp',
  'modal.bestPrice': 'Paras hinta',
  'modal.noQuotes': 'Tälle pyynnölle ei ole tarjouksia saatavilla',
  'modal.noProvidersFound': 'Palveluntarjoajia ei löydy',
  'payment.unavailableFor': 'Ei maksutapoja saatavilla valuutalle {currency}',
  'skeleton.poweredBy': 'Palvelun tarjoaa NowRamp',
  'error.createOrderFailed': 'Tilauksen luonti epäonnistui',
  'errorStep.returnToMerchant': 'Palaa kauppiaalle',
  'confirm.cryptoOnNetwork': '{crypto} verkossa {network}',
  'payment.name.card': 'Kortti',
  'payment.name.bankTransfer': 'Pankkisiirto',
  'payment.name.ach': 'ACH',
  'rate.updatesInLabel': 'Rate updates in',
  'rate.networkFeeIncl': 'Network fee incl.',
  'rate.rateTooltip': 'As the market is highly volatile, we can fix the exchange rate for no longer than 30 seconds.',
  'rate.networkFeeTooltip': 'Includes a fee charged by blockchain to execute the transaction.',
  'rate.feeIncluded': '{percentage}% incl.',
  'receive.fetchingRate': 'Fetching best rate...',
  'redirect.tabHelper': 'If the new tab has not opened, click the button above.',
};

export default fi;
